export const secrets = {
  // Azure
  REACT_APP_AZURE_ACTIVE_DIRECTORY_LOGIN_REDIRECT_PATH: "auth/login/complete",
  REACT_APP_AZURE_ACTIVE_DIRECTORY_TENANT_ID: "d3db4717-2853-4110-bc89-f41b4c7eb1c6",
  REACT_APP_AZURE_ACTIVE_DIRECTORY_CLIENT_ID: "13e9caee-f34c-4b8a-a718-a04390766f69",
  // Errbit
  REACT_APP_ERRBIT_HOST: 'https://errbit.tccs.io',
  REACT_APP_ERRBIT_PROJECT_ID: '1',
  REACT_APP_ERRBIT_PROJECT_KEY: '443a6426edcec9d646633181267d7bef',
} as const;

export type Secrets = typeof secrets
